import React, { CSSProperties } from 'react';

import { Spin } from 'antd';

function Loading({
  style = {},
  spinBGColor,
  isTipShow = true,
}: {
  style?: CSSProperties;
  spinBGColor?: string;
  isTipShow?: boolean;
}) {
  return (
    <div
      style={{
        width: '100%',
        height: '90vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <Spin
        tip={isTipShow ? 'Loading' : ''}
        style={{
          backgroundColor: spinBGColor,
        }}
      >
        <div
          className="content"
          style={{
            padding: '50px',
          }}
        />
      </Spin>
    </div>
  );
}

export default Loading;
